import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-company-threshold-edit-modal',
  templateUrl: './company-threshold-edit-modal.component.html',
  styleUrls: ['./company-threshold-edit-modal.component.css']
})
export class CompanyThresholdEditModalComponent implements OnInit {
  @Input() threshold: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveThreshold(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
